export default [
    {
        title: '购买相关问题',
        items: [
            {
                q: '调用API服务如何收费？',
                a: [
                    'API服务有两种收费模式：预付模式和月结模式。',
                    '预付模式需要先支付方可使用。预付模式下购买的调用次数永久有效，QPS限额为1。',
                    '月结模式为先使用后付款，需要事先约定每月调用次数和QPS限额, QPS限额最高档为20。服务开始后，每月月初将生成上月的账单。'
                ]
            },
            {
                q: '如何申请免费试用？',
                a: [
                    'API 免费试用是我们为客户提供的免费福利，可在正式购买前免费试用API 服务。免费试用 API 不需要预先向账户充值，也不需要事后支付费用，且提供的功能与付费版本完全一致。客户可以~{联系商务}{inquiry}申请免费试用。',
                    '免费服务有以下这些限制：',
                    '1. 针对不同的服务，每个用户在正式购买前都能申请一次免费试用。但不可重复申请多次，且在付费使用后，不能再申请免费试用。',
                    '2. 并发数限制为1 QPS：由于资源有限，在调用繁忙的情况下，您的请求有可能会受到并发限制。',
                    '3. 调用次数为1000次：每个用户只能享用该服务免费调用1000次。'
                ]
            },
            {
                q: '如何购买预付套餐？',
                a: [
                    '客户可~{联系商务}{inquiry}，选购需要的预付套餐调用次数，然后在服务开始前及时向账户充值。预付套餐需从账户余额扣款成功后，服务方可被使用。',
                ]
            },
            {
                q: '充值的余额有过期时间吗？',
                a: [
                    '余额充值没有过期时间，可以长期使用。',
                ]
            },
            {
                q: '预付套餐的并发数可以提高吗？',
                a: [
                    '预付套餐的默认并发数为1 QPS。但当客户同时购买了预付套餐和月结套餐时，在月结套餐的生效时间内，预付套餐的并发数可升级到和月结套餐一致。'
                ]
            },
            {
                q: '如何购买月结套餐？',
                a: [
                    '客户可~{联系商务}{inquiry}，选购需要的月结套餐的每月调用次数以及QPS限额。服务开始后，每月月初将生成上月的账单。请登录账户查看账单并按照合同规定及时付款。否则将影响服务的正常使用。'
                ]
            },
            {
                q: '购买月结套餐可以叠加吗？',
                a: [
                    '每一次购买月结套餐时需要指定时间长度、并发数量和可使用调用次数。同一服务时间内，不可重复叠加两个月结套餐的QPS限额和可使用调用次数。'
                ]
            },
            {
                q: '本月使用的调用次数超出选购的月结套餐基本次数会怎么样？',
                a: [
                    '本月的调用次数超出超出选购的月结套餐基本次数的部分，如果客户此时仍有剩余的预付套餐的可使用次数，将从预付套餐可使用次数中扣除。否则，将按照超额次数计算，在月末生成本月的超额订单，并按照合同规定的超额单次费用收费。',
                ]
            },
            {
                q: '月结套餐临时需要提高QPS限额怎么办？',
                a: [
                    '本月如果出现流量突增的情况，请提前联系我们的商务。在资源有富余的情况下，可以协商临时提高QPS限额。但如果出现长期的流量需求增加情况，请联系商务修改，修改下月月结套餐的QPS限额。',
                ]
            },
            {
                q: '购买服务可以立刻生效吗？',
                a: [
                    '购买服务时可选择开始生效的时间，服务最早生效时间为第二天的0点0分0秒。但如果选择升级月结套餐，最早的生效时间为下月1号。',
                ]
            },
        ]
    },
    {
        title: '技术相关问题',
        items: [
            {
                q: '什么是QPS？QPS限额怎么计算？',
                a: [
                    'QPS限额是指服务器在一秒内可支持的请求个数，相当于一个API接口每秒可以允许请求的并发上限数量',
                    '例：QPS限额 = 5，假如有多个客户端一起调用某个API接口，1秒钟内发起了6个请求，当第6个请求发出后会返回一个状态，提示你超过 QPS 限制，请求不予处理。',
                ]
            },
            {
                q: '实际使用的QPS超过购买套餐的QPS时，服务如何处理？',
                a: [
                    '超并发服务器不会进行排队处理，直接返回403超并发错误。如果您未来一段时间内业务访问量超出了相应接口的并发上限，可以升级月结套餐来提高并发。',
                ]
            },
            {
                q: '目前API平台支持哪些图片上传方式？',
                a: [
                    '目前平台支持图片：图片Base64编码、图片URL。',
                ]
            },
            {
                q: '识别的图片格式有什么要求？',
                a: [
                    '支持JPG、JPEG，不支持GIF、PNG图片。',
                ]
            },
            {
                q: '什么是base64编码？',
                a: [
                    '图片的base64编码指将一张图片数据编码成一组字符串，使用该字符串代替图像。您可以首先读取一张图片，然后用Base64格式编码即可。',
                    '注：图片的base64编码是不包含图片头的，所以在编码之后的字符串之前请添加 data:image/jpg;base64, 详情请见对应产品的API文档。',
                ]
            },
            {
                q: '平台服务的请求图片大小限制是？',
                a: [
                    '图片大小目前限制是5M。',
                ]
            },
            {
                q: '缺少参数的报错',
                a: [
                    '1. 缺少access key/access secret，以及access key/access secret错误，服务端会返回"AK/SK认证失败, secret_key错误或服务无访问权限"等错误。',
                    '2. 若用户配置了access key/access secret为失效状态，则返回"AK/SK认证失败, 当前access key已经失效"等信息',
                    '3. 目前我们支持application/json格式的POST请求，不支持form等格式以及其他任何方式的请求。使用其他方式发送请求，服务器会解析不到相关参数，所以即使传入了相关参数仍然会报缺少参数的错误。',
                    '4. 详细信息请参看对应产品的API文档相关信息。',
                ]
            },
        ]
    }
]